<template>
  <div class="emitter">
    <div
      v-for="p of particles"
      :key="p.id"
      :style="{
        transform: `translate(${p.x}px, ${p.y}px) rotate(${p.a}rad)`,
        opacity: `${p.l}`,
      }"
      class="particle"
    >
      {{ p.text }}
    </div>
  </div>
</template>

<script>

const defaults = {
  text: 'z',
  interval: { value: 1100, random: 500 },
  life: { value: 10000, random: 10 },
  sx: { value: 5, random: 0 },
  sy: { value: -5, random: 0.5 },
  sa: { value: 0, random: 0 },
  dx: { value: 0, random: 0.2 },
  ddx: { value: 0, random: 0 },
  dy: { value: -0.3, random: 0.001 },
  ddy: { value: 0, random: 0.0001 },
  da: { value: 0, random: 0.01 },
  dda: { value: 0, random: 0.001 },
};

export default {
  name: 'Emitter',
  props: {
    text: { type: String, default: 'z' },
    config: { type: Object, default() { return {}; } },
  },
  data() {
    return {
      lastId: 0,
      lastEmitted: Date.now() + this.randomize('interval'),
      particles: [],
    };
  },
  mounted() {
    this.emit();
  },
  destroyed() {
    cancelAnimationFrame(this.emitter);
  },
  methods: {
    emit() {
      this.emitter = requestAnimationFrame(() => {
        // spawn new
        let count = 0;
        let interval = this.randomize('interval');
        while (count < 10 && Date.now() - this.lastEmitted > interval) {
          this.createParticle();
          this.lastEmitted += interval;
          count += 1;
          interval = this.randomize('interval');
        }

        this.particles.forEach((p) => {
          const particle = p;
          particle.x += p.dx;
          particle.dx += p.ddx;
          particle.y += p.dy;
          particle.dy += p.ddy;
          particle.a += p.da;
          particle.da += p.dda;
          particle.life -= Date.now() - this.lastEmitted;
          particle.l = p.life / p.maxLife;
        });

        if (count > 0) {
          this.lastEmitted = Math.max(this.lastEmitted, Date.now() - 100);
        }

        // remove old
        this.particles = this.particles.filter(p => p.life > 0);

        this.emit();
      });
    },
    createParticle() {
      const life = this.randomize('life');
      this.lastId += 1;
      this.particles.push({
        id: this.lastId,
        text: this.config.text || defaults.text,
        x: this.randomize('sx'),
        y: this.randomize('sy'),
        a: this.randomize('sa'),
        life,
        maxLife: life,
        dx: this.randomize('dx'),
        dy: this.randomize('dy'),
        ddx: this.randomize('ddx'),
        ddy: this.randomize('ddy'),
        da: this.randomize('da'),
        dda: this.randomize('dda'),
      });
    },
    randomize(key) {
      let config = this.config[key];
      if (config === undefined) {
        config = defaults[key];
      }
      if (typeof config === 'object') {
        return config.value + this.nrand(config.random);
      }
      return config || 0;
    },
    nrand(v) {
      const r = Math.random() * (v * 2) - v;
      return r;
    },
  },
};
</script>

<style lang="scss" scoped>
.particle {
  z-index: 10;
  font-size: 12px;
  position: absolute;
  color: darkblue
}
</style>
